var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewPaymentOptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 0.599609,
    width: 69.5197,
    height: 69.5197,
    rx: 5,
    fill: "#EDF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 28.6007C22.667 27.1072 22.667 26.3604 22.9576 25.79C23.2133 25.2882 23.6213 24.8803 24.123 24.6246C24.6934 24.334 25.4402 24.334 26.9337 24.334H45.067C46.5605 24.334 47.3072 24.334 47.8776 24.6246C48.3794 24.8803 48.7873 25.2882 49.043 25.79C49.3337 26.3604 49.3337 27.1072 49.3337 28.6007V41.4007C49.3337 42.8941 49.3337 43.6409 49.043 44.2113C48.7873 44.7131 48.3794 45.121 47.8776 45.3767C47.3072 45.6673 46.5605 45.6673 45.067 45.6673H26.9337C25.4402 45.6673 24.6934 45.6673 24.123 45.3767C23.6213 45.121 23.2133 44.7131 22.9576 44.2113C22.667 43.6409 22.667 42.8941 22.667 41.4007V28.6007Z",
    fill: "#C3D2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.667 29.6673H49.3337M28.0003 40.334H33.3337M38.667 40.334H44.0003M26.9337 45.6673H45.067C46.5605 45.6673 47.3072 45.6673 47.8776 45.3767C48.3794 45.121 48.7873 44.7131 49.043 44.2113C49.3337 43.6409 49.3337 42.8941 49.3337 41.4007V28.6007C49.3337 27.1072 49.3337 26.3604 49.043 25.79C48.7873 25.2882 48.3794 24.8803 47.8776 24.6246C47.3072 24.334 46.5605 24.334 45.067 24.334H26.9337C25.4402 24.334 24.6934 24.334 24.123 24.6246C23.6213 24.8803 23.2133 25.2882 22.9576 25.79C22.667 26.3604 22.667 27.1072 22.667 28.6007V41.4007C22.667 42.8941 22.667 43.6409 22.9576 44.2113C23.2133 44.7131 23.6213 45.121 24.123 45.3767C24.6934 45.6673 25.4402 45.6673 26.9337 45.6673Z",
    stroke: "#2828F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPaymentOptionIcon);
export default __webpack_public_path__ + "static/media/newPaymentOptionIcon.d9783769ea783db2c71bbff542ca4163.svg";
export { ForwardRef as ReactComponent };